import axios, { RawAxiosRequestConfig } from 'axios';
import { StatusCodes } from 'http-status-codes';
import getAPIAccount from '@api/account';
import { Logger } from '@utils/logger';

export default {
    namespaced: true,

    state: () => ({
        data: null,
    }),

    actions: {
        async get(store) {
            try {
                const client = getAPIAccount(this.$context);

                const cfg: RawAxiosRequestConfig = {
                    validateStatus: (status: number) => [StatusCodes.OK, StatusCodes.UNAUTHORIZED].includes(status),
                    method: 'GET',
                    url: '/v2/account',
                };

                const resp = await client.request(cfg);
                store.commit('setUser', resp.data.account);
            } catch (error) {
                Logger.error({ error });
            }
        },

        async logout(store) {
            try {
                const client = getAPIAccount(this.$context);

                const cfg: RawAxiosRequestConfig = {
                    validateStatus: (status: number) => [StatusCodes.NO_CONTENT].includes(status),
                    method: 'POST',
                    url: '/v2/auth/logout',
                };

                await client.request(cfg);
                store.commit('setUser', null);
            } catch (error) {
                Logger.error({ error });
            }
        },

        async getUserCloud(store: never, token: string): Promise<any> {
            try {
                const defaults: RawAxiosRequestConfig = {
                    timeout: 10000,
                    withCredentials: true,
                };
                const client = axios.create(defaults);
                const url = `https://www.acronis.com/en-us/inapp/home/ati/matrix/cloud.html?ott=${token || ''}`;
                const { data } = await client.get(url);
                return data;
            } catch (error) {
                Logger.error({ error });
                return null;
            }
        },
    },

    mutations: {
        setUser(state, user) {
            if (user?.country === 'UK') {
                state.data = { ...user, country: 'GB' };
                return;
            }
            state.data = user;
        },
    },
};
